import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import Edit from './Edit.vue';
import { NahradniHodinovaSazba } from './nahradniHodinovaSazba';
import { NahradniSazbaLakovaci } from './nahradniSazbaLakovaci';
import { PrevzitHodnoty } from './prevzitHodnoty';
import { SmluvniCenaND } from './smluvniCenaND';

export const router = new Path().addChildren([
	new Path(NAME, { Edit }, CRUMB_LABEL_KEY),

	NahradniHodinovaSazba.router,
	NahradniSazbaLakovaci.router,
	PrevzitHodnoty.router,
	SmluvniCenaND.router,
]);
